import { isValidUrl } from "@api";
import { Button, Stack } from "@mui/material";
import { isInternalOfferSource } from "@root/utils/enums/offer";
import { useMemo } from "react";
import { useModalOfferContext } from "./context";

interface IApplyActionsProps {
  isApply?: boolean;
}

export const ApplyActions = ({ isApply }: IApplyActionsProps) => {
  const { offer, onSubmit, onCancel, loadingUrl, loading, candidateId, searchUrlDone, mode } = useModalOfferContext();

  const loadingButtonText: string = useMemo(() => {
    if (mode === "editApply") {
      return "Modifier";
    }
    if (isApply) {
      return "Créer";
    }
    if (candidateId && !offer.offerId) {
      return "Créer et épingler";
    }
    if (!offer.offerId) {
      return "Créer";
    }
    if (searchUrlDone && offer.offerId) {
      if (!candidateId) {
        if (!isInternalOfferSource(offer.source)) {
          return "Afficher";
        }
        return "Enregistrer et afficher";
      }
      if (!isInternalOfferSource(offer.source)) {
        return "Épingler";
      }
      return "Enregistrer et épingler";
    }
    return "Enregistrer";
  }, [offer, candidateId, isApply, mode, searchUrlDone]);

  return (
    <Stack
      direction="row"
      sx={{
        gap: 1,
      }}
    >
      <Button
        id="cancel-btn"
        onClick={() => onCancel()}
        color="primary"
        variant="outlined"
        name="cancel"
        aria-labelledby="cancel"
      >
        Annuler
      </Button>
      <Button
        id="confirm-btn"
        onClick={onSubmit}
        color="primary"
        variant="contained"
        name="confirm"
        aria-labelledby="validate"
        loading={loading}
        disabled={loadingUrl || !!(offer?.externalURL && !isValidUrl(offer.externalURL))}
      >
        {loadingButtonText}
      </Button>
    </Stack>
  );
};
